import { Table } from '~/components/ui/table';

type Props = {
  duration: number;
};

export function formatDuration(duration: number) {
  const totalSeconds = Math.floor(duration / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

  return `${minutes}:${formattedSeconds}`;
}

export function DurationCell({ duration }: Props) {
  const formattedDuration = formatDuration(duration);

  return (
    <Table.Cell hideBelow="md" textAlign="center">
      {formattedDuration}
    </Table.Cell>
  );
}
